<section
  *ngIf="data && data.queue && data.queue.length > 0"
  dir="ltr"
  class="position-fixed bottom-0 end-0 start-0"
>
  <div class="container-fluid py-3">
    <div
      class="audio-container w-100 d-flex align-items-center justify-content-between"
    >
      <div class="audio-info d-flex align-items-center">
        <div
          [ngClass]="{ active: isPlay }"
          class="wave d-none d-lg-flex align-items-end justify-content-between"
        >
          <div class="wave-move"></div>
          <div class="wave-move"></div>
          <div class="wave-move"></div>
        </div>
        <div class="position-relative">
          <img
            loading="lazy"
            [src]="
              data.queue[data.index].image
                ? data.queue[data.index].image
                : 'assets/imgs/default-media.png'
            "
            [alt]="data.queue[data.index].song"
          />
          <span
            (click)="showAudioInfo = !showAudioInfo"
            class="show-audio-info d-md-none position-absolute top-0 rounded-circle d-flex align-items-center justify-content-center"
          >
            <i
              [ngClass]="showAudioInfo ? 'fa-angle-up' : 'fa-angle-down'"
              class="fa-solid"
            ></i>
          </span>
          <div
            *ngIf="showAudioInfo"
            class="audio-sm-info d-md-none shadow position-absolute start-0 rounded p-1"
          >
            <h5
              (mouseenter)="showSongTitle = true"
              (mouseleave)="showSongTitle = false"
              class="text-white mb-0 text-nowrap"
            >
              {{ data.queue[data.index].song }}
            </h5>
            <span
              (mouseenter)="showSingerTitle = true"
              (mouseleave)="showSingerTitle = false"
              class="text-nowrap"
              >{{ data.queue[data.index].singer }}</span
            >
          </div>
        </div>
        <div class="audio-details position-relative d-none d-md-block">
          <p
            *ngIf="showSongTitle"
            class="audio-song text-nowrap mb-0 text-white bg-secondary rounded px-1 py-0 position-absolute bottom-100 start-0"
          >
            {{ data.queue[data.index].song }}
          </p>
          <p
            *ngIf="showSingerTitle"
            class="audio-singer text-nowrap mb-0 text-white bg-secondary rounded px-1 py-0 position-absolute bottom-100 start-0"
          >
            {{ data.queue[data.index].singer }}
          </p>
          <h5
            (mouseenter)="showSongTitle = true"
            (mouseleave)="showSongTitle = false"
            class="text-white mb-0"
          >
            {{ data.queue[data.index].song }}
          </h5>
          <span
            (mouseenter)="showSingerTitle = true"
            (mouseleave)="showSingerTitle = false"
            >{{ data.queue[data.index].singer }}</span
          >
        </div>
      </div>
      <div class="audio-controls-1">
        <div class="d-flex align-items-center justify-content-center">
          <button
            [disabled]="data.index === 0"
            (click)="stepBackward()"
            class="btn p-0 border-0 shadow-none"
          >
            <i class="fa-solid fa-backward-step"></i>
          </button>
          <button
            (click)="togglePlay()"
            class="btn btn-play-pause p-0 border-0 shadow-none rounded-circle d-flex align-items-center justify-content-center"
          >
            <i [ngClass]="isPlay ? 'fa-pause' : 'fa-play'" class="fa-solid"></i>
          </button>
          <button
            [disabled]="data.index + 1 === data.queue?.length"
            (click)="stepForward()"
            class="btn p-0 border-0 shadow-none"
          >
            <i class="fa-solid fa-forward-step"></i>
          </button>
        </div>
        <div class="audio-timeline d-flex align-items-center">
          <span class="text-white">{{ currentTime }}</span>
          <div
            #timelineContainer
            (mousemove)="handleTimelineUpdate($event)"
            (mousedown)="toggleScrubbing($event)"
            class="timeline-container w-100 d-flex align-items-center position-relative"
          >
            <div class="timeline position-relative w-100 overflow-x-hidden">
              <div #preload class="preload position-absolute top-0"></div>
            </div>
            <span
              class="current-timeline position-absolute bottom-100 text-white px-1 rounded text-nowrap"
              >{{ currentTimeline }}</span
            >
          </div>
          <span class="text-white">{{ totalTime }}</span>
        </div>
      </div>
      <div
        class="audio-controls-2 d-flex align-items-center justify-content-end"
      >
        <div
          #volumeContainer
          [attr.data-volume-level]="volumeLevel"
          class="volume-container d-flex align-items-center position-relative"
        >
          <button
            (click)="toggleMute()"
            class="btn shadow-none border-0 d-none d-md-block"
          >
            <i class="fa-solid fa-volume-high volume-high-icon d-none"></i>
            <i class="fa-solid fa-volume-low volume-low-icon d-none"></i>
            <i class="fa-solid fa-volume-xmark volume-muted-icon d-none"></i>
          </button>
          <button
            (click)="showVolumeSlider = !showVolumeSlider"
            class="btn shadow-none border-0 d-block d-md-none py-1 px-2"
          >
            <i class="fa-solid fa-volume-high volume-high-icon d-none"></i>
            <i class="fa-solid fa-volume-low volume-low-icon d-none"></i>
            <i class="fa-solid fa-volume-xmark volume-muted-icon d-none"></i>
          </button>
          <input
            #volumeSliderMD
            class="d-none d-md-block"
            (input)="slideVolume()"
            type="range"
            min="0"
            max="1"
            step="any"
            value="1"
          />
          <input
            #volumeSliderSM
            [ngClass]="showVolumeSlider ? 'd-block d-md-none' : 'd-none'"
            class="position-absolute start-50 translate-middle-x"
            orient="vertical"
            (input)="slideVolume()"
            type="range"
            min="0"
            max="1"
            step="any"
            value="1"
          />
        </div>
        <button
          (click)="downloadAudio()"
          class="btn border-0 shadow-none d-none d-md-block"
        >
          <i class="fa-solid fa-download"></i>
        </button>
        <div class="btn-group dropup d-none d-md-block">
          <button
            type="button"
            class="btn border-0 shadow-none dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-list-ol"></i>
          </button>
          <ul class="dropdown-menu py-0">
            <li
              class="dropdown-item"
              *ngFor="let audio of data.queue; index as i"
              (click)="playFromQueue(i)"
              [ngClass]="{ 'active text-white': data.index === i }"
            >
              {{ audio.song }}
            </li>
          </ul>
        </div>
        <button
          type="button"
          class="btn border-0 shadow-none py-1 px-2 px-md-3 py-md-2"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>
</section>
<div
  class="modal fade"
  id="staticBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div
        class="modal-body text-center"
        translate="digitalLibrary.closeMessage"
      ></div>
      <div
        class="modal-footer d-flex align-items-center justify-content-center"
      >
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          translate="digitalLibrary.no"
        ></button>
        <button
          (click)="turnOffPlayer()"
          type="button"
          class="btn btn-info text-white player-close"
          data-bs-dismiss="modal"
          translate="digitalLibrary.yes"
        ></button>
      </div>
    </div>
  </div>
</div>
<audio
  #audio
  preload="auto"
  (play)="isPlay = true"
  (pause)="isPlay = false"
  (loadeddata)="loadedDuration()"
  (progress)="bufferedAudio()"
  (timeupdate)="updateDuration()"
  (volumechange)="changeVolume()"
  (ended)="endedAudio()"
></audio>
